module.exports = __webpack_public_path__ + "static/media/ABOUT1.f99ea99d.jpg";